'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';
import { trackCtaClick, type CtaLocation } from '@/lib/analytics-cta';

interface CtaLinkProps {
  href: string;
  label: string;
  location: CtaLocation;
  className?: string;
  external?: boolean;
  children: ReactNode;
}

// Thin wrapper so the comparison page can stay a server component while its
// CTAs still report cta_click (a money action on the scoreboard).
export default function CtaLink({ href, label, location, className, external, children }: CtaLinkProps) {
  const onClick = () => trackCtaClick(label, location, href);
  if (external) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick}>
        {children}
      </a>
    );
  }
  return (
    <Link href={href} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
